/**
 * A set of utility functions that adapts Request models to their UI equivalent
 */
import {RequestTask, UIRequestTask} from 'requests/tasks/RequestTaskConstants';
import {PreparedUISampleGroup} from 'workflows/samples/PreparedSampleGroupConstants';

export function adaptRequestTaskToUIRequestTask(requestTasks: Array<RequestTask>): Array<UIRequestTask> {
  return requestTasks.map((requestTask) => ({
    cid: requestTask.id,
    schemaId: requestTask.schemaId,
    tags: requestTask.tags,
  }));
}

export function adaptSampleGroupsToPreparedUISampleGroups(
  preparedSampleGroups: Array<PreparedUISampleGroup>
): Array<PreparedUISampleGroup> {
  const filteredSampleGroups = preparedSampleGroups.filter(({id}) => id != null);
  return filteredSampleGroups.map(({id, tags}) => ({cid: id!, tags}));
}
